import * as React from "react";
import { SVGProps } from "react";

const SvgTenClubs = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 288 402"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M276.3.1H11.6S.5.4.5 15.1v371.7c0 14.7 11.1 15 11.1 15h264.6s11.1-.3 11.1-15V15.1c.1-14.7-11-15-11-15Z"
      fill="#fff"
    />
    <mask
      id="ten-clubs_svg__b"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={216}
      width={288}
      height={186}
    >
      <path
        d="M169.6 216.9c-56.4 0-112.8 0-169.2.1v169.8c0 14.7 11.1 15 11.1 15h264.7s11.1-.3 11.1-15v-170c-39.2 0-78.4.1-117.7.1Z"
        fill="url(#ten-clubs_svg__a)"
      />
    </mask>
    <g mask="url(#ten-clubs_svg__b)">
      <path
        d="M169.6 216.9c-56.4 0-112.8 0-169.2.1v169.8c0 14.7 11.1 15 11.1 15h264.7s11.1-.3 11.1-15v-170c-39.2 0-78.4.1-117.7.1Z"
        fill="url(#ten-clubs_svg__c)"
      />
    </g>
    <mask
      id="ten-clubs_svg__e"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={288}
      height={201}
    >
      <path
        d="M.5 200.5h72.4c69.6 0 139.2 0 208.7.1h5.7V15.1c0-14.7-11.1-15-11.1-15H11.6S.5.4.5 15.1v185.4Z"
        fill="url(#ten-clubs_svg__d)"
      />
    </mask>
    <g mask="url(#ten-clubs_svg__e)">
      <path
        d="M.5 200.5h72.4c69.6 0 139.2 0 208.7.1h5.7V15.1c0-14.7-11.1-15-11.1-15H11.6S.5.4.5 15.1v185.4Z"
        fill="url(#ten-clubs_svg__f)"
      />
    </g>
    <mask
      id="ten-clubs_svg__h"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={5}
      y={0}
      width={283}
      height={402}
    >
      <path
        d="M286.8 15.1v371c0 14.7-11.1 15-11.1 15h-265s-2.4-.1-5-1.6c2.9 2.1 5.8 2.2 5.8 2.2h264.6s11.1-.3 11.1-15V15.1c0-14.7-11.1-15-11.1-15h-.6c.2 0 11.3.3 11.3 15Z"
        fill="url(#ten-clubs_svg__g)"
      />
    </mask>
    <g mask="url(#ten-clubs_svg__h)">
      <path
        d="M286.8 15.1v371c0 14.7-11.1 15-11.1 15h-265s-2.4-.1-5-1.6c2.9 2.1 5.8 2.2 5.8 2.2h264.6s11.1-.3 11.1-15V15.1c0-14.7-11.1-15-11.1-15h-.6c.2 0 11.3.3 11.3 15Z"
        fill="url(#ten-clubs_svg__i)"
      />
    </g>
    <mask
      id="ten-clubs_svg__k"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={283}
      height={402}
    >
      <path
        d="M1.1 386.8v-371C1.1 1.1 12.2.8 12.2.8h265s2.4.1 5 1.6C279.3.3 276.4.2 276.4.2H11.6S.5.5.5 15.2v371.7c0 14.7 11.1 15 11.1 15h.6c0-.2-11.1-.5-11.1-15.1Z"
        fill="url(#ten-clubs_svg__j)"
      />
    </mask>
    <g mask="url(#ten-clubs_svg__k)">
      <path
        d="M1.1 386.8v-371C1.1 1.1 12.2.8 12.2.8h265s2.4.1 5 1.6C279.3.3 276.4.2 276.4.2H11.6S.5.5.5 15.2v371.7c0 14.7 11.1 15 11.1 15h.6c0-.2-11.1-.5-11.1-15.1Z"
        fill="url(#ten-clubs_svg__l)"
      />
      <mask
        id="ten-clubs_svg__n"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={29}
        width={2}
        height={347}
      >
        <path
          d="M.5 29.1v346.3l.6-2.1V35.4l-.6-6.3Z"
          fill="url(#ten-clubs_svg__m)"
        />
      </mask>
      <g mask="url(#ten-clubs_svg__n)">
        <path
          d="M.5 29.1v346.3l.6-2.1V35.4l-.6-6.3Z"
          fill="url(#ten-clubs_svg__o)"
        />
      </g>
    </g>
    <path
      d="M29.1 79.9c-.6 7.5-4.8 12.7-4.8 12.7h9.6c.1 0-4.2-5.2-4.8-12.7Z"
      fill="#000"
    />
    <path
      d="M36.1 71.5c-1 0-1.9.2-2.7.5l-.1-.1c1.7-1.3 2.8-3.3 2.8-5.6 0-3.9-3.1-7-7-7s-7 3.1-7 7c0 2.4 1.2 4.6 3.1 5.8-.9-.5-2-.7-3.1-.7-3.9 0-7 3.1-7 7s3.1 7 7 7c3.8 0 6.8-3 7-6.7.2 3.7 3.2 6.7 7 6.7 3.9 0 7-3.1 7-7 0-3.8-3.1-6.9-7-6.9ZM21.8 45.4c0 1 .1 1.7.2 2.2.1.5.3.9.6 1.2.3.3.7.6 1.2.7.5.2 1.2.3 2 .4.8.1 1.8.2 3.1.2V52H10.2v-1.9c1.9-.1 3.2-.2 4-.3.8-.1 1.4-.4 1.8-.6.4-.3.7-.7.9-1.2.2-.5.3-1.4.3-2.6V24.8c0-.7-.1-1.2-.4-1.5-.2-.3-.6-.5-1-.5-.5 0-1.3.3-2.3.8-1 .5-2.2 1.3-3.7 2.3l-1.1-2 11.9-7.1H22c-.1 1.6-.2 3.9-.2 6.7v21.9ZM38.2 52.4c-3.7 0-6.4-1.4-8.2-4.3-1.8-2.9-2.7-7.2-2.7-13.1 0-3.1.3-5.8.8-8.1s1.3-4.1 2.3-5.6c1-1.5 2.2-2.6 3.6-3.3 1.4-.7 2.9-1.1 4.5-1.1 3.7 0 6.5 1.4 8.3 4.3 1.8 2.9 2.7 7.2 2.7 13 0 6-1 10.5-2.9 13.6-1.9 3.1-4.7 4.6-8.4 4.6Zm-5.9-18.1c0 5.5.5 9.6 1.5 12.1 1 2.6 2.6 3.9 4.8 3.9 2 0 3.6-1.2 4.6-3.6 1-2.4 1.5-6.2 1.5-11.3 0-3.9-.3-7-.8-9.4-.5-2.4-1.2-4.1-2.1-5.2-.9-1-2-1.6-3.3-1.6-1.2 0-2.1.3-2.9 1-.8.7-1.4 1.7-1.9 3s-.8 2.9-1 4.8c-.3 1.8-.4 3.9-.4 6.3ZM259.5 320.9c.6-7.5 4.8-12.7 4.8-12.7h-9.6s4.2 5.2 4.8 12.7Z"
      fill="#000"
    />
    <path
      d="M252.5 329.3c1 0 1.9-.2 2.7-.5l.1.1c-1.7 1.3-2.8 3.3-2.8 5.6 0 3.9 3.1 7 7 7s7-3.1 7-7c0-2.4-1.2-4.6-3.1-5.8.9.5 2 .7 3.1.7 3.9 0 7-3.1 7-7s-3.1-7-7-7c-3.8 0-6.8 3-7 6.7-.2-3.7-3.2-6.7-7-6.7-3.9 0-7 3.1-7 7 0 3.8 3.2 6.9 7 6.9ZM266.9 355.4c0-1-.1-1.7-.2-2.2-.1-.5-.3-.9-.6-1.2-.3-.3-.7-.6-1.2-.7-.5-.2-1.2-.3-2-.4-.8-.1-1.8-.2-3.1-.2v-1.9h18.7v1.9c-1.9.1-3.2.2-4 .3-.8.1-1.4.4-1.8.6-.4.3-.7.7-.9 1.2-.2.5-.3 1.4-.3 2.6V376c0 .7.1 1.2.4 1.5.2.3.6.5 1 .5.5 0 1.3-.3 2.3-.8 1-.6 2.2-1.3 3.7-2.3l1.1 2-11.9 7.1h-1.4c.1-1.6.2-3.9.2-6.7v-21.9ZM250.5 348.3c3.7 0 6.4 1.4 8.2 4.3 1.8 2.9 2.7 7.2 2.7 13.1 0 3.1-.3 5.8-.8 8.1-.6 2.3-1.3 4.1-2.3 5.6-1 1.5-2.2 2.6-3.6 3.3-1.4.7-2.9 1.1-4.5 1.1-3.7 0-6.5-1.4-8.3-4.3-1.8-2.9-2.7-7.2-2.7-13 0-6 1-10.5 2.9-13.6 1.8-3 4.6-4.6 8.4-4.6Zm5.8 18.2c0-5.5-.5-9.6-1.5-12.1-1-2.6-2.6-3.9-4.8-3.9-2 0-3.6 1.2-4.6 3.6-1 2.4-1.5 6.2-1.5 11.3 0 3.9.3 7 .8 9.4.5 2.4 1.2 4.1 2.1 5.2.9 1 2 1.6 3.3 1.6 1.2 0 2.1-.3 2.9-1 .8-.7 1.4-1.7 1.9-3s.8-2.9 1-4.8c.3-1.9.4-4 .4-6.3ZM143.9 273.3c-1.2-14.8-9.6-25.2-9.6-25.2h19.2s-8.3 10.4-9.6 25.2Z"
      fill="#000"
    />
    <path
      d="M171.7 276.2c0-7.7-6.2-13.9-13.9-13.9-7.5 0-13.6 5.9-13.9 13.3-.3-7.4-6.4-13.3-13.9-13.3-7.7 0-13.9 6.2-13.9 13.9s6.2 13.9 13.9 13.9c2.2 0 4.3-.5 6.2-1.5-3.8 2.5-6.2 6.8-6.2 11.6 0 7.7 6.2 13.9 13.9 13.9s13.9-6.2 13.9-13.9c0-4.5-2.2-8.5-5.5-11.1l.1-.1c1.7.7 3.5 1.1 5.4 1.1 7.7 0 13.9-6.2 13.9-13.9ZM143.9 126.8c-1.2 14.8-9.6 25.2-9.6 25.2h19.2s-8.3-10.4-9.6-25.2Z"
      fill="#000"
    />
    <path
      d="M157.8 110c-1.9 0-3.7.4-5.4 1.1l-.1-.1c3.3-2.5 5.5-6.5 5.5-11.1 0-7.7-6.2-13.9-13.9-13.9S130 92.2 130 99.9c0 4.8 2.5 9.1 6.2 11.6-1.9-.9-4-1.5-6.2-1.5-7.7 0-13.9 6.2-13.9 13.9s6.2 13.9 13.9 13.9c7.5 0 13.6-5.9 13.9-13.3.3 7.4 6.4 13.3 13.9 13.3 7.7 0 13.9-6.2 13.9-13.9s-6.2-13.9-13.9-13.9ZM196.9 88.2c-1.2 14.8-9.6 25.2-9.6 25.2h19.2s-8.3-10.4-9.6-25.2Z"
      fill="#000"
    />
    <path
      d="M210.8 71.5c-1.9 0-3.7.4-5.4 1.1l-.1-.1c3.3-2.5 5.5-6.6 5.5-11.1 0-7.7-6.2-13.9-13.9-13.9S183 53.7 183 61.4c0 4.8 2.5 9.1 6.2 11.6-1.9-.9-4-1.5-6.2-1.5-7.7 0-13.9 6.2-13.9 13.9s6.2 13.9 13.9 13.9c7.5 0 13.6-5.9 13.9-13.3.3 7.4 6.4 13.3 13.9 13.3 7.7 0 13.9-6.2 13.9-13.9s-6.2-13.9-13.9-13.9ZM196.9 313.6c1.2-14.8 9.6-25.2 9.6-25.2h-19.2s8.4 10.4 9.6 25.2Z"
      fill="#000"
    />
    <path
      d="M183 330.4c1.9 0 3.7-.4 5.4-1.1l.1.1c-3.3 2.5-5.5 6.6-5.5 11.1 0 7.7 6.2 13.9 13.9 13.9s13.9-6.2 13.9-13.9c0-4.8-2.5-9.1-6.2-11.6 1.9.9 4 1.5 6.2 1.5 7.7 0 13.9-6.2 13.9-13.9s-6.2-13.9-13.9-13.9c-7.5 0-13.6 5.9-13.9 13.3-.3-7.4-6.4-13.3-13.9-13.3-7.7 0-13.9 6.2-13.9 13.9 0 7.6 6.3 13.9 13.9 13.9ZM196.9 168.6c-1.2 14.8-9.6 25.2-9.6 25.2h19.2c0-.1-8.3-10.4-9.6-25.2Z"
      fill="#000"
    />
    <path
      d="M210.8 151.8c-1.9 0-3.7.4-5.4 1.1l-.1-.1c3.3-2.5 5.5-6.6 5.5-11.1 0-7.7-6.2-13.9-13.9-13.9S183 134 183 141.7c0 4.8 2.5 9.1 6.2 11.6-1.9-.9-4-1.5-6.2-1.5-7.7 0-13.9 6.2-13.9 13.9s6.2 13.9 13.9 13.9c7.5 0 13.6-5.9 13.9-13.3.3 7.4 6.4 13.3 13.9 13.3 7.7 0 13.9-6.2 13.9-13.9s-6.2-13.9-13.9-13.9ZM196.9 233.3c-1.2-14.8-9.6-25.2-9.6-25.2h19.2s-8.3 10.4-9.6 25.2Z"
      fill="#000"
    />
    <path
      d="M224.7 236.1c0-7.7-6.2-13.9-13.9-13.9-7.5 0-13.6 5.9-13.9 13.3-.3-7.4-6.4-13.3-13.9-13.3-7.7 0-13.9 6.2-13.9 13.9S175.3 250 183 250c2.2 0 4.3-.5 6.2-1.5-3.7 2.5-6.2 6.8-6.2 11.6 0 7.7 6.2 13.9 13.9 13.9s13.9-6.2 13.9-13.9c0-4.5-2.2-8.5-5.5-11.1l.1-.1c1.7.7 3.5 1.1 5.4 1.1 7.7 0 13.9-6.2 13.9-13.9ZM90.9 88.2c-1.2 14.8-9.6 25.2-9.6 25.2h19.2s-8.3-10.4-9.6-25.2Z"
      fill="#000"
    />
    <path
      d="M104.8 71.5c-1.9 0-3.7.4-5.4 1.1l-.1-.1c3.3-2.5 5.5-6.6 5.5-11.1 0-7.7-6.2-13.9-13.9-13.9S77 53.7 77 61.4c0 4.8 2.5 9.1 6.2 11.6-1.9-.9-4-1.5-6.2-1.5-7.7 0-13.9 6.2-13.9 13.9S69.3 99.3 77 99.3c7.5 0 13.6-5.9 13.9-13.3.3 7.4 6.4 13.3 13.9 13.3 7.7 0 13.9-6.2 13.9-13.9s-6.2-13.9-13.9-13.9ZM90.9 168.6c-1.2 14.8-9.6 25.2-9.6 25.2h19.2c0-.1-8.3-10.4-9.6-25.2Z"
      fill="#000"
    />
    <path
      d="M104.8 151.8c-1.9 0-3.7.4-5.4 1.1l-.1-.1c3.3-2.5 5.5-6.6 5.5-11.1 0-7.7-6.2-13.9-13.9-13.9S77 134 77 141.7c0 4.8 2.5 9.1 6.2 11.6-1.9-.9-4-1.5-6.2-1.5-7.7 0-13.9 6.2-13.9 13.9s6.2 13.9 13.9 13.9c7.5 0 13.6-5.9 13.9-13.3.3 7.4 6.4 13.3 13.9 13.3 7.7 0 13.9-6.2 13.9-13.9s-6.2-13.9-13.9-13.9ZM90.9 233.3c-1.2-14.8-9.6-25.2-9.6-25.2h19.2s-8.3 10.4-9.6 25.2Z"
      fill="#000"
    />
    <path
      d="M118.7 236.1c0-7.7-6.2-13.9-13.9-13.9-7.5 0-13.6 5.9-13.9 13.3-.3-7.4-6.4-13.3-13.9-13.3-7.7 0-13.9 6.2-13.9 13.9S69.3 250 77 250c2.2 0 4.3-.5 6.2-1.5-3.7 2.5-6.2 6.8-6.2 11.6 0 7.7 6.2 13.9 13.9 13.9s13.9-6.2 13.9-13.9c0-4.5-2.2-8.5-5.5-11.1l.1-.1c1.7.7 3.5 1.1 5.4 1.1 7.7 0 13.9-6.2 13.9-13.9ZM90.9 313.6c1.2-14.8 9.6-25.2 9.6-25.2H81.3s8.4 10.4 9.6 25.2Z"
      fill="#000"
    />
    <path
      d="M77 330.4c1.9 0 3.7-.4 5.4-1.1l.1.1c-3.3 2.5-5.5 6.6-5.5 11.1 0 7.7 6.2 13.9 13.9 13.9s13.9-6.2 13.9-13.9c0-4.8-2.5-9.1-6.2-11.6 1.9.9 4 1.5 6.2 1.5 7.7 0 13.9-6.2 13.9-13.9s-6.2-13.9-13.9-13.9c-7.5 0-13.6 5.9-13.9 13.3-.3-7.4-6.4-13.3-13.9-13.3-7.7 0-13.9 6.2-13.9 13.9 0 7.6 6.3 13.9 13.9 13.9Z"
      fill="#000"
    />
    <defs>
      <radialGradient
        id="ten-clubs_svg__a"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(139.499 -136.86) scale(580.826)"
      >
        <stop offset={0.616} />
        <stop offset={0.752} stopColor="#020202" />
        <stop offset={0.804} stopColor="#090909" />
        <stop offset={0.841} stopColor="#151515" />
        <stop offset={0.872} stopColor="#262626" />
        <stop offset={0.899} stopColor="#3C3C3C" />
        <stop offset={0.922} stopColor="#585858" />
        <stop offset={0.944} stopColor="#797979" />
        <stop offset={0.963} stopColor="#9F9F9F" />
        <stop offset={0.982} stopColor="#CBCBCB" />
        <stop offset={0.998} stopColor="#F9F9F9" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="ten-clubs_svg__c"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(139.499 -136.86) scale(580.826)"
      >
        <stop offset={0.616} stopColor="#fff" />
        <stop offset={0.788} stopColor="#FDFDFD" />
        <stop offset={0.854} stopColor="#F6F6F6" />
        <stop offset={0.901} stopColor="#EAEAEA" />
        <stop offset={0.94} stopColor="#D9D9D9" />
        <stop offset={0.974} stopColor="#C3C3C3" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="ten-clubs_svg__d"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(145.245 370.739) scale(416.199)"
      >
        <stop offset={0.616} />
        <stop offset={0.71} stopColor="#020202" />
        <stop offset={0.762} stopColor="#0A0A0A" />
        <stop offset={0.805} stopColor="#181818" />
        <stop offset={0.842} stopColor="#2C2C2C" />
        <stop offset={0.875} stopColor="#464646" />
        <stop offset={0.906} stopColor="#656565" />
        <stop offset={0.935} stopColor="#8A8A8A" />
        <stop offset={0.963} stopColor="#B6B6B6" />
        <stop offset={0.988} stopColor="#E5E5E5" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="ten-clubs_svg__f"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(145.245 370.739) scale(416.199)"
      >
        <stop offset={0.616} stopColor="#fff" />
        <stop offset={0.747} stopColor="#FDFDFD" />
        <stop offset={0.821} stopColor="#F5F5F5" />
        <stop offset={0.88} stopColor="#E7E7E7" />
        <stop offset={0.932} stopColor="#D3D3D3" />
        <stop offset={0.978} stopColor="#BABABA" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="ten-clubs_svg__g"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-11.788 -.106) scale(462.125)"
      >
        <stop offset={0.099} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="ten-clubs_svg__i"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-11.788 -.106) scale(462.125)"
      >
        <stop offset={0.099} stopColor="#fff" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="ten-clubs_svg__j"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(78.853 116.972) scale(393.607)"
      >
        <stop />
        <stop offset={0.007} stopColor="#090909" />
        <stop offset={0.048} stopColor="#373737" />
        <stop offset={0.093} stopColor="#626262" />
        <stop offset={0.142} stopColor="#888" />
        <stop offset={0.195} stopColor="#A8A8A8" />
        <stop offset={0.254} stopColor="#C4C4C4" />
        <stop offset={0.32} stopColor="#DADADA" />
        <stop offset={0.397} stopColor="#EBEBEB" />
        <stop offset={0.493} stopColor="#F6F6F6" />
        <stop offset={0.627} stopColor="#FDFDFD" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="ten-clubs_svg__l"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(78.853 116.972) scale(393.607)"
      >
        <stop stopColor="#fff" />
        <stop offset={0.141} stopColor="#fff" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="ten-clubs_svg__m"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(-462.21 0 0 -462.229 299.813 -.107)"
      >
        <stop offset={0.099} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="ten-clubs_svg__o"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(-462.21 0 0 -462.229 299.813 -.107)"
      >
        <stop offset={0.099} stopColor="#fff" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
    </defs>
  </svg>
);

export default SvgTenClubs;
